import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import PlayerAnalytics from "../Analytics/PlayerAnalytics";
import ViewRegion from "../Analytics/ViewRegion";
import PartnerPayout from "./PartnerPayout";
import PartnerPayout_Analytics from "./PartnerPayout_Analytics";
import PartnerPayout_History from "./PartnerPayment_History";
import { Tab, Tabs, Nav } from "react-bootstrap";
import MessageBox from "../../../components/CommonComponents/MessageBox";

const PartnerAnalytics = () => {
    const { fetchRequest } = useMyContext();
    const BaseUrl = process.env.REACT_APP_Baseurl;
    const [partners, setPartners] = useState([]);
    const [selectedPartner, setSelectedPartner] = useState({ value: "all", label: "All Partners" });
    const [activeTab, setActiveTab] = useState("player-analytics");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchPartners();
    }, []);

    const fetchPartners = async () => {
        setLoading(true);
        await fetchRequest({
            method: "GET",
            url: `${BaseUrl}/admin/partner/index`,
            params: { limit: 9999 }, // Fetch all partners for the dropdown
        })
            .then((response) => {
                const partnerData = response?.data || [];
                const options = [
                    { value: "all", label: "All Partners" },
                    ...partnerData.map((p) => ({
                        value: p.id,
                        label: `${p.user_username || 'N/A'} (${p.user_email || 'N/A'})`,
                    })),
                ];
                setPartners(options);
            })
            .catch((err) => {
                console.error("Error fetching partners:", err);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handlePartnerChange = (selectedOption) => {
        setSelectedPartner(selectedOption);
    };

    return (
        <div className="container-fluid py-4">
            <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
                <div>
                    <h3 className="mb-0">Partner Analytics</h3>
                    <p className="text-muted">Monitor performance and payouts across your partner network</p>
                </div>
                <div style={{ minWidth: "300px" }}>
                    <label className="form-label small fw-bold text-uppercase text-muted">Select Partner</label>
                    <Select
                        options={partners}
                        value={selectedPartner}
                        onChange={handlePartnerChange}
                        placeholder="Search partners..."
                        isSearchable
                        isLoading={loading}
                        classNamePrefix="partner-select"
                    />
                </div>
            </div>

            <div className="card shadow-sm border-0 rounded-4">
                <div className="card-body p-0">
                    <Tabs
                        activeKey={activeTab}
                        onSelect={(k) => setActiveTab(k)}
                        className="custom-analytics-tabs px-3 pt-2"
                        id="partner-analytics-tabs"
                    >
                        <Tab eventKey="player-analytics" title="Player Analytics">
                            <div className="p-3">
                                <PlayerAnalytics partnerId={selectedPartner.value === "all" ? null : selectedPartner.value} />
                            </div>
                        </Tab>
                        <Tab eventKey="view-region" title="View By Region">
                            <div className="p-3">
                                <ViewRegion partnerId={selectedPartner.value === "all" ? null : selectedPartner.value} />
                            </div>
                        </Tab>
                        <Tab eventKey="payouts" title="Payouts">
                            <div className="p-3">
                                <PartnerPayout partnerId={selectedPartner.value === "all" ? null : selectedPartner.value} />
                            </div>
                        </Tab>
                        <Tab eventKey="payout-monetization" title="Payout Monetization">
                            <div className="p-3">
                                <PartnerPayout_Analytics partnerId={selectedPartner.value === "all" ? null : selectedPartner.value} />
                            </div>
                        </Tab>
                        <Tab eventKey="payout-history" title="Payout History">
                            <div className="p-3">
                                <PartnerPayout_History partnerId={selectedPartner.value === "all" ? null : selectedPartner.value} />
                            </div>
                        </Tab>
                    </Tabs>
                </div>
            </div>

            <style>{`
                .custom-analytics-tabs .nav-link {
                    border: none;
                    color: #6c757d;
                    font-weight: 500;
                    padding: 1rem 1.5rem;
                    border-bottom: 3px solid transparent;
                    transition: all 0.3s ease;
                }
                .custom-analytics-tabs .nav-link.active {
                    color: #0d6efd !important;
                    background: transparent !important;
                    border-bottom-color: #0d6efd !important;
                }
                .custom-analytics-tabs .nav-link:hover:not(.active) {
                    border-bottom-color: #dee2e6;
                }
                .partner-select__control {
                    border-radius: 8px !important;
                    border-color: #dee2e6 !important;
                    box-shadow: none !important;
                }
                .partner-select__control:hover {
                    border-color: #0d6efd !important;
                }
            `}</style>
        </div>
    );
};

export default PartnerAnalytics;
